var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    rx: 4,
    fill: "#C6FB55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_9131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 8.5H11C10.8011 8.5 10.6103 8.57902 10.4697 8.71967C10.329 8.86032 10.25 9.05109 10.25 9.25V22C10.25 22.3978 10.408 22.7794 10.6893 23.0607C10.9706 23.342 11.3522 23.5 11.75 23.5H28.25C28.6478 23.5 29.0294 23.342 29.3107 23.0607C29.592 22.7794 29.75 22.3978 29.75 22V9.25C29.75 9.05109 29.671 8.86032 29.5303 8.71967C29.3897 8.57902 29.1989 8.5 29 8.5ZM28.25 22H11.75V10.9562L19.4937 18.0531C19.632 18.1796 19.8126 18.2498 20 18.2498C20.1874 18.2498 20.368 18.1796 20.5062 18.0531L28.25 10.9562V22Z",
    fill: "#141046"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_9131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.ebc94cc394d0b855b313a0dca009e23c.svg";
export { ForwardRef as ReactComponent };